import { render, staticRenderFns } from "./ModalSettingAccountRequestData.vue?vue&type=template&id=9b774e2e&"
import script from "./ModalSettingAccountRequestData.vue?vue&type=script&lang=js&"
export * from "./ModalSettingAccountRequestData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports